// Base
import Link from 'next/link'
import Image from 'next/image'

// Components
import { Flex, Text, TrustpilotStars, Box } from 'yard-utilities/components'

interface TrustpilotProps {
  theme?: 'white' | 'black'
  spacing?: { sm: number; lg?: number }
}

const Trustpilot = ({
  theme = 'white',
  spacing = { sm: 64 }
}: TrustpilotProps) => {
  return (
    <Link href="https://www.trustpilot.com/review/ratepunk.com" target="_blank">
      <Box padding={{ sm: [24, 0] }} spacing={spacing} backgroundColor="white">
        <Flex
          alignItems="center"
          justifyContent="center"
          rowGap={{ sm: 16 }}
          flexDirection="column"
        >
          <Image
            src={`/images/icons/trustpilot-${theme}.svg`}
            width="98"
            height="24"
            alt="Trustpilot logo"
          />
          <TrustpilotStars size={176} score={4.4} />

          <div>
            <div id="how-it-works-anchor" />

            <Text variant="body-3" fontFamily="lato" align="center">
              TrustScore <b>4.4</b>
            </Text>
          </div>
        </Flex>
      </Box>
    </Link>
  )
}

export default Trustpilot
